import React, { useState, useEffect, useRef } from "react";
import Tg from "./toggle";
import PluralitySocialConnect from 'plurality-social-connect';
import SideMenu from './Sidemenu';

function Nav() {
  const childRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [Profileurl,setProfileurl] = useState(null);



  const info = localStorage.getItem("userinfo")
  const url = localStorage.getItem("url");
  const accountAddress = localStorage.getItem("filWalletAddress")
  const aseetData = localStorage.getItem("Interest");

  // console.log(aseetData);


  useEffect(() => {
    
  }, []);


  function logout(){
    alert("Logout")
    localStorage.clear();
    window.location.reload();
    // Logout();

  }


  const handleDataReturned = async (data) => {

    const receivedData = JSON.parse(JSON.stringify(data.data[0].profileData))

    const parsedData = JSON.parse(receivedData);


// Access the name field

const fetchedfrom= data.data[0].dataFetchedFrom;

console.log("Thee  data is fetched from",fetchedfrom);
localStorage.setItem("Fetchedfrom",data.data[0].dataFetchedFrom);
// const combine = {data.data[0].assetData[0] + ','+ data.data[0].assetData[1]}
localStorage.setItem("Interest",data.data[0].assetData[0] + ' ' + ' ' + ','+ ' ' + ' '+ data.data[0].assetData[1]);
localStorage.setItem("first",data.data[0].assetData[0])
localStorage.setItem("second",data.data[0].assetData[1])
const username = parsedData.name;
const profileUrl = parsedData.profileUrl;
setProfileurl(profileUrl);
localStorage.setItem("userinfo",username);
localStorage.setItem("url",profileUrl);

console.log("The profile url is",profileUrl);

console.log("The username is",username);

    childRef.current.closeSocialConnectPopup();
      alltest();
    setLoading(false);
  }



  async function alltest(){

    const add = await PluralitySocialConnect.getConnectedAccount();
  }

  // Web3 function handles
  const handleGetAllAccounts = (data) => {
      const receivedData = JSON.parse(JSON.stringify(data))
      console.log("Get all accounts:", receivedData);
      alert(JSON.stringify(data));
  };
  const handleGetConnectedAccount = (data) => {
      const receivedData = JSON.parse(JSON.stringify(data))
      const add  = data['data']['address'];
      localStorage.setItem("filWalletAddress",add)
  
      console.log("Get connected account:", receivedData);

      // alert(JSON.stringify(data));
      window.location.reload();


  };
  const handleMessageSignature = (data) => {
      const receivedData = JSON.parse(JSON.stringify(data))
      console.log("Get message signature:", receivedData);
      alert(JSON.stringify(data));
  };
  const handleVerifyMessageSignature = (data) => {
      const receivedData = JSON.parse(JSON.stringify(data))
      console.log("Verify message signature:", receivedData);
      alert(JSON.stringify(data));
  };
  const handleGetBalance = (data) => {
      const receivedData = JSON.parse(JSON.stringify(data))
      console.log("Get balance:", receivedData);
      alert(JSON.stringify(data));
  };
  const handleSendTransaction = (data) => {
      const receivedData = JSON.parse(JSON.stringify(data))
      console.log("Send transaction:", receivedData);
      alert(JSON.stringify(data));
  };
  const handleGetBlockNumber = (data) => {
      const receivedData = JSON.parse(JSON.stringify(data))
      console.log("Get block number:", receivedData);
      alert(JSON.stringify(data));
  };
  const handleGetTransactionCount = (data) => {
      const receivedData = JSON.parse(JSON.stringify(data))
      console.log("Get transaction count:", receivedData);
      alert(JSON.stringify(data));
  };
  const handleReadFromContract = (data) => {
      const receivedData = JSON.parse(JSON.stringify(data))
      console.log("Read from contract:", receivedData);
      alert(JSON.stringify(data));
  };
  const handleWriteToContract = (data) => {
      const receivedData = JSON.parse(JSON.stringify(data))
      console.log("Write to contract:", receivedData);
      alert(JSON.stringify(data));
  };
  const handleErrorMessage = (data) => {
      const receivedData = JSON.parse(JSON.stringify(data))
      console.log("Get error message:", receivedData);
      alert(JSON.stringify(data));
  };


  function truncateAddress(add) {
    const len = add.length;
    if (len < 11) return add;
    return add.substring(0, 6) + "..." + add.substring(len - 4, len);
  }

  return (
    <>
      <div className='navbar navbar-expand navbar-light bg-white topbar mb-4 shadow fixed-top-bar'>
        <div className="text-lg mx-3 no-underline">
          <a className="flex items-center justify-center alchemy-link" href="/">
            <div className="mmh text-lg mx-3">Treasure Dao</div>
            
          </a>
        </div>
        <button
          id="sidebarToggleTop"
          className="btn btn-link d-md-none rounded-circle mr-3"
          onClick={Tg}
        >
          <i className="fa fa-bars" />
        </button>
        <ul className="navbar-nav ml-auto">
          {/* Nav Item - Search Dropdown (Visible Only XS) */}
          <li className="nav-item dropdown no-arrow d-sm-none">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="searchDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="fas fa-search fa-fw" />
            </a>
            <div
              className="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in"
              aria-labelledby="searchDropdown"
            >
              <form className="form-inline mr-auto w-100 navbar-search">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control bg-light border-0 small"
                    placeholder="Search for..."
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                  />
                  <div className="input-group-append">
                    <button className="btn btn-primary" type="button">
                      <i className="fas fa-search fa-sm" />
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </li>
          {accountAddress !== null && !isOpen && (
            <>
              <div className='name flex'>
                {info}
              </div>
            </>
          )}
          <div className="topbar-divider d-none d-sm-block" />
          {accountAddress !== null && !isOpen && (
            <>
              <li className="nav-item dropdown no-arrow">
                <div
                  className="nav-link dropdown-toggle"
                  onClick={() => setIsOpen(true)}
                  id="userDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <img
                    className="img-profile rounded-circle"
                    src={url}
                  />
                </div>
              </li>
            </>
          )}
        </ul>
        <div className='maincomp flex'>
          {accountAddress && isOpen && (
            <SideMenu
              address={accountAddress}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              accountAddress={accountAddress}
              logout={logout}
              userInfo={info}
            />
          )}
          {accountAddress == null && !loading ? (
            <PluralitySocialConnect
              options={{ apps: 'facebook,twitter' }}
              onProfileDataReturned={handleDataReturned}
            
              onGetAllAccounts={handleGetAllAccounts}
                onGetConnectedAccount={handleGetConnectedAccount}
                onGetMessageSignature={handleMessageSignature}
                onVerifyMessageSignature={handleVerifyMessageSignature}
                onGetBalance={handleGetBalance}
                onSendTransaction={handleSendTransaction}
                onGetBlockNumber={handleGetBlockNumber}
                onGetTransactionCount={handleGetTransactionCount}
                onReadFromContract={handleReadFromContract}
                onWriteToContract={handleWriteToContract}
                onErrorMessage={handleErrorMessage}
              ref={childRef}
            />
          ) : (
            loading && <button className="btn bg-gradient-1 text-gray-900 transition ease-in-out duration-500 transform hover:scale-110">Loading...</button>
          )}
        </div>
        
      </div>
     
    </>
  );
}

export default Nav;
